import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const SnoozeStyled = styled.li`
  display: inline-block;
  margin-right: 5px;
  margin-bottom: 5px;
  padding: 5px 0 6px 8px;
  border-radius: 2px;
  background-color: ${COLORS.line};
`;

export default SnoozeStyled;
